import { render, staticRenderFns } from "./FeriasPublicidad.vue?vue&type=template&id=39f6ed44&"
import script from "./FeriasPublicidad.vue?vue&type=script&lang=js&"
export * from "./FeriasPublicidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports